import * as React from "react";
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Spinner from '../../../common/components/spinner/spinner';
import { Button } from 'primereact/button';
import { Growl } from 'primereact/growl';
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FileModel } from "../../../models/fileModel";
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import * as Constants from '../../../common/constants';
import DataSyncService from '../../../services/dataSyncService';
import { SchedulerFilterSettingsModel } from "../../../models/dataSynchronization";
import { getEnumLabel } from '../../../common/functions/helperFunctions';
import { SyncSchedulerFilter } from './syncSchedulerFilter';
import { Toolbar } from 'primereact/toolbar';
import { SyncSchedulerModel } from "../../../models/dataSynchronization";
import { SyncSchedulerWrapperModel } from "../../../models/dataSynchronization";
import { SyncSettingsModel } from "../../../models/dataSynchronization";
import SyncSettingsAddEditDialog from './syncSettingsAddEditDialog';
import { Checkbox } from 'primereact/checkbox';
import { FullSyncResultModel } from "../../../models/dataSynchronization";
import SyncSchedulerReportDialog from './syncSchedulerReportDialog';

interface IProps {
}

interface IState {
  isLoading: boolean;
  error: any;
  isVisibleConfirmDialog: boolean;
  isVisibleSchedulerAddEditDialog: boolean;
  validationMessage: string;
  from: number;
  numberOfRows: number;
  totalRecordsCount: number;
  syncSettings: SyncSettingsModel;
  pendingScheduler: SyncSchedulerModel;
  executedSchedulers: Array<SyncSchedulerModel>;
  fiterSettings: SchedulerFilterSettingsModel;
  currentReport: FullSyncResultModel;
  isVisibleSchedulerReportDialog: boolean;
}

const initFrom = 0;
const numberOfRows = 10;

class SyncSchedulerContainer extends React.Component<IProps, IState> {
  growl: any;
  dataSyncService = new DataSyncService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      validationMessage: '',
      isLoading: false,
      isVisibleConfirmDialog: false,
      isVisibleSchedulerAddEditDialog: false,
      from: initFrom,
      numberOfRows: numberOfRows,
      totalRecordsCount: 0,
      pendingScheduler: new SyncSchedulerModel(),
      syncSettings: new SyncSettingsModel(),
      executedSchedulers: new Array<SyncSchedulerModel>(),
      fiterSettings: new SchedulerFilterSettingsModel(),
      currentReport: new FullSyncResultModel(),
      isVisibleSchedulerReportDialog: false
    };
  }

  componentDidMount() {
    this.getAll(this.state.from, this.state.numberOfRows);
  }

  getAll = (from: number, numberOfRows: number) => {
    this.setState({
      isLoading: true
    });

    this.dataSyncService.getSettingsAndAllSchedulers(from, numberOfRows, this.state.fiterSettings)
      .then(
        (data: SyncSchedulerWrapperModel) => {
          this.setState({
            isLoading: false,
            syncSettings: data.syncSettings,
            pendingScheduler: data.pendingScheduler,
            executedSchedulers: data.executedSchedulers,
            totalRecordsCount: data.totalRecordsCount
          });
        },
        error => {
          this.setState({
            error
          });
          this.setState({
            isLoading: false
          });
        }
      );
  }

  getSettingsAndShcedulers = (from: number, numberOfRows: number) => {
    // this.setState({
    //   isLoading: true
    // });

    // this.dataSyncService.getAllImported(from, numberOfRows, this.state.importDataFiterSettings)
    //   .then(
    //     (data: ImportDataListModel) => {
    //       this.setState({
    //         isLoading: false,
    //         from: from,
    //         importedRows: data.importedMedicineData,
    //         totalRecordsCount: data.totalRecordsCount
    //       });
    //     },
    //     error => {
    //       this.setState({
    //         error
    //       });
    //       this.setState({
    //         isLoading: false
    //       });
    //     }
    //   );
  }

  getSchedulerReport = (id) => {
    // this.dataSyncService.getImported(id)
    //   .then(
    //     (data: ImportSyncMedicineGridModel) => {
    //       this.setcurrenDataSourceRow(data);
    //       this.setState({
    //         isLoading: false
    //       });
    //     },
    //     error => {
    //       this.setState({
    //         error,
    //         isLoading: false
    //       });
    //     });
  }


  handleOnPageClick = (e) => {
    const startIndex = e.first;
    // this.getAll(startIndex, this.state.numberOfRows);
  }

  handleDeleteClick = (id) => {
    // this.getImported(id);
    this.setState({
      isVisibleConfirmDialog: true
    });
  };

  deleteScheduler = (id) => {
    // this.setState({
    //   isVisibleConfirmDialog: false,
    //   isLoading: true
    // });

    // this.dataSyncService.deleteDataSourceRow(id)
    //   .then(
    //     data => {
    //       this.getAll(this.state.from, this.state.numberOfRows);
    //       this.setState({
    //         isLoading: false
    //       });
    //     },
    //     error => {
    //       this.setState({
    //         error,
    //         isLoading: false
    //       });
    //     });
  }

  handleSyncSettingsAddEditClick = (syncSettingsId) => {
    if (!syncSettingsId) {
      this.setCurrentSyncSetttings(new SyncSettingsModel());
      this.showEditDialog(true);
    } else {
      //TODO: get method here for edit
      this.setState({
        isLoading: true
      });
      this.setCurrentSyncSetttings(this.state.syncSettings);
      this.showEditDialog(true);
      this.setState({
        isLoading: false
      });
    }
  }

  showEditDialog = (show: boolean) => {
    this.setState({
      isVisibleSchedulerAddEditDialog: show,
      validationMessage: ''
    })
  };

  setCurrentSyncSetttings(syncSettings: SyncSettingsModel) {
    this.setState({
      syncSettings: syncSettings
    });
  }

  handleCancelButton = () => {
    this.showEditDialog(false);
  };

  handleCancelReportButton = () => {
    this.showReportDialog(false);
  };

  handleSearchButtonClick = (settings: SchedulerFilterSettingsModel) => {
  }

  handleSaveClick = (syncSettings: SyncSettingsModel) => {
    this.setState({
      isLoading: true
    });

    if (!syncSettings.syncSettingsId) { // Add
      this.dataSyncService.addSyncSettings(syncSettings)
        .then(
          (data) => {
            if (close) {
              this.showEditDialog(false);
            }
            this.getAll(this.state.from, this.state.numberOfRows);
            // this.setState({
            //   isLoading: false
            // });
          },
          error => {
            this.showEditDialog(false);
            //this.setcurrentMedicine(new AdminMedicineModel());
            this.setState({
              error
            });
            this.setState({
              isLoading: false
            });
          }
        );
    } else { // Edit
      this.dataSyncService.editSyncSettings(syncSettings)
        .then(
          (data) => {
            if (close) {
              this.showEditDialog(false);
            }
            this.getAll(this.state.from, this.state.numberOfRows);
            // this.setState({
            //   isLoading: false
            // });
          },
          error => {
            this.showEditDialog(false);
            this.setState({
              error
            });
            this.setState({
              isLoading: false
            });
          });
    }
  }

  handleReportClick = (schedulerId: number) => {
    this.setState({
      isLoading: true
    });

    this.dataSyncService.getSchedulerReport(schedulerId)
      .then(
        (data: FullSyncResultModel) => {
          this.setCurrentSchedulerReport(data);
          this.showReportDialog(true);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        }
      );
  }

  showReportDialog = (show: boolean) => {
    this.setState({
      isVisibleSchedulerReportDialog: show,
      validationMessage: ''
    })
  };

  setCurrentSchedulerReport(report: FullSyncResultModel) {
    this.setState({
      currentReport: report
    });
  }

  public render() {
    const { isLoading, error, executedSchedulers, syncSettings, pendingScheduler } = this.state;

    let syncSettingsButton: any;
    if (syncSettings) {
      syncSettingsButton =
        <Button
          style={{ marginRight: "10px", marginBottom: "5px", width: 'auto' }}
          icon="pi pi-cog"
          className="p-button-warning"
          type="button"
          label="Update settings"
          tooltip="Scheduler settings"
          tooltipOptions={{ position: 'top' }}
          onClick={() => this.handleSyncSettingsAddEditClick(syncSettings.syncSettingsId)}
        />;
    } else {
      syncSettingsButton =
        <Button
          style={{ marginRight: "10px", marginBottom: "5px", width: 'auto' }}
          icon="pi pi-cog"
          className="p-button-success"
          type="button"
          label="Add settings"
          tooltip="Scheduler settings"
          tooltipOptions={{ position: 'top' }}
          onClick={() => this.handleSyncSettingsAddEditClick(null)}
        />;
    }


    let nextExecElement: any;
    if (pendingScheduler && pendingScheduler.nextExecutionDate) {
      nextExecElement =
        <div style={{ float: "right" }}>
          <div><label>Next Execution Date&nbsp;</label></div>
          <strong>{pendingScheduler.nextExecutionDate ? HelperFunctions.fomatDateTimeAsString(new Date(pendingScheduler.nextExecutionDate)) : ""}</strong>
        </div>;
    } else {
      nextExecElement = null;
    }

    return (
      <>
        <div>
          {isLoading ? <Spinner /> : null}
          {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}
          {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
          <Growl ref={(el) => this.growl = el} />

          <Toolbar style={{ marginTop: '10px', marginBottom: '10px' }}>
            <div style={{ marginTop: "10px", marginBottom: '10px' }}>
              <h3>Scheduler</h3>
            </div>
            {syncSettingsButton}
            {nextExecElement}
          </Toolbar>
          <div>
            <DataTable
              value={executedSchedulers}
              paginator={true}
              lazy={true}
              rows={this.state.numberOfRows}
              totalRecords={this.state.totalRecordsCount}
              onPage={(event) => this.handleOnPageClick(event)}
              first={this.state.from}
            >
              <Column
                field="nextExecutionDate"
                header="Started At"
                body={(rowData, column) =>
                  <div>
                    {rowData.nextExecutionDate ? HelperFunctions.fomatDateTimeAsString(new Date(rowData.nextExecutionDate)) : ""}
                  </div>
                }
              />
              <Column
                field="executedAt"
                header="Finished At"
                body={(rowData, column) =>
                  <div>
                    {rowData.executedAt ? HelperFunctions.fomatDateTimeAsString(new Date(rowData.executedAt)) : ""}
                  </div>
                }
              />
              <Column
                header="All"
                style={{ textAlign: "center", width: "8em" }}
                body={(rowData, column) =>
                  <div>
                    <Button
                      type="button"
                      icon="pi pi-refresh"
                      className={"p-button-info"}
                      tooltip={"All to synchronize"}
                      tooltipOptions={{ position: 'top' }}
                      label={'(' + rowData.mainResult.allToSyncCount + ')'}
                      style={{ width: "5em" }}
                    />
                  </div>
                }
              />
              <Column
                header="New"
                style={{ textAlign: "center", width: "8em" }}
                body={(rowData, column) =>
                  <div>
                    <Button
                      type="button"
                      icon="pi pi-download"
                      className={"p-button-success"}
                      tooltip={"Medicines inserted"}
                      tooltipOptions={{ position: 'top' }}
                      label={'(' + rowData.mainResult.insertedCount + ')'}
                      style={{ width: "5em" }}
                    />
                  </div>
                }
              />
              <Column
                header="Updated"
                style={{ textAlign: "center", width: "8em" }}
                body={(rowData, column) =>
                  <div>
                    <Button
                      type="button"
                      icon="pi pi-pencil"
                      className={"p-button-warning"}
                      tooltip={"Medicines updated"}
                      tooltipOptions={{ position: 'top' }}
                      label={'(' + rowData.mainResult.updatedCount + ')'}
                      style={{ width: "5em" }}
                    />
                  </div>
                }
              />
              <Column
                header="Failed"
                style={{ textAlign: "center", width: "8em" }}
                body={(rowData, column) =>
                  <div>
                    <Button
                      type="button"
                      icon="pi pi-exclamation-triangle"
                      className={"p-button-danger"}
                      tooltip={"Transactions failed"}
                      tooltipOptions={{ position: 'top' }}
                      label={'(' + rowData.mainResult.failedCount + ')'}
                      style={{ width: "5em" }}
                    />
                  </div>
                }
              />
              <Column
                header="Actions"
                style={{ textAlign: "center", width: "8em" }}
                body={(rowData, column) =>
                  <div>
                    <Button
                      type="button"
                      icon="pi pi-bars"
                      className="p-button-info"
                      tooltip="Full Report"
                      tooltipOptions={{ position: 'top' }}
                      style={{ marginRight: ".5em" }}
                      onClick={() => this.handleReportClick(rowData.syncSchedulerId)}
                    />
                  </div>
                }
              />
            </DataTable>
          </div>
        </div>

        {this.state.isVisibleSchedulerAddEditDialog ? (
          <SyncSettingsAddEditDialog
            saveClick={this.handleSaveClick}
            cancelClick={this.handleCancelButton}
            syncSettings={this.state.syncSettings}
            isVisible={this.state.isVisibleSchedulerAddEditDialog}
          />
        ) : null}

        {this.state.isVisibleSchedulerReportDialog ? (
          <SyncSchedulerReportDialog
            cancelClick={this.handleCancelReportButton}
            schedulerReport={this.state.currentReport}
            isVisible={this.state.isVisibleSchedulerReportDialog}
          />
        ) : null}

        {/* <ConfirmDialog
          headerTitle="Confirm Dialog"
          isVisible={this.state.isVisibleConfirmDialog}
          yesClick={() => { this.deleteDataSource(this.state.currentGridMedicine.importedMedicineId) }}
          noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
          Are you sure that you want to delete "{this.state.currentGridMedicine.importedMedicineName}"?
        </ConfirmDialog> */}
      </>
    );
  }
}

export default SyncSchedulerContainer;